class Timeline {
    // INIT
    constructor(selector, callback) {
        this.callback = callback;
        this.bloc = document.querySelector(selector);
        this.percentTimeline = 0;
        this.percentHover = 0;
        this.radius = 4;
        this.radiusHoverCircle = 14;
        this.radiusMax = (this.radius > this.radiusHoverCircle ? this.radius : this.radiusHoverCircle) + 2;
        this.hoverHeight = 30;
        this.hoverRange = 80;
        this.lineWidth = 3;
        this.lineWidthHoverCircle = 2;

        this.colorDone = "rgba(255,255,255,1)";
        this.colorNotDone = "rgba(255,255,255,0.5)";

        this.cursorX = -1000;
        this.cursorY = -1000;

        this.isClicked = false;
        this.clickRange = 100;

        if (this.bloc) {
            this.liste = this.bloc.querySelector("ul");
            this.items = this.bloc.querySelectorAll("li");
            if (this.liste && this.items.length > 0) {
                this.init();
            }
        }
    }

    init() {        
        // init new canvas
        this.canvas = document.createElement("canvas");
        // this.canvas.removeEventListener("mousemove", this.CheckCursor.bind(this));
        this.canvas.id = Math.random();
        if(!window.matchMedia("(max-width: 1099px)").matches) {
            this.canvas.addEventListener("mousemove", this.CheckCursor.bind(this));
        }
        this.canvas.addEventListener("click", this.changeVideo.bind(this));

        this.context = this.canvas.getContext("2d");

        this.nbItems = this.items.length;

        this.bloc.insertBefore(this.canvas, this.liste);

        this.render();
    }

    // MAJ

    updateTimer(percent) {
        this.percentTimeline = percent;
    }

    CheckCursor(e) {
        this.cursorX = e.offsetX;
        this.cursorY = e.offsetY;
    }

    changeVideo(e) {
        this.isClicked = true;
    }

    // RENDER

    render(t) {
        this.canvas.width = this.bloc.clientWidth;

        this.percentHover = 0;

        for (let i = 0; i < this.nbItems; i++) {
            this.drawSpot(i);
        }

        for (let i = 0; i < this.nbItems; i++) {
            this.drawText(i);
        }

        for (let i = 0; i < this.nbItems; i++) {
            this.drawEtape(i, i + 1);
        }

        for (let i = 0; i < this.nbItems; i++) {
            this.drawHoverCircle(i);
        }

        this.isClicked = false;

        requestAnimationFrame(this.render.bind(this));
    }

    drawSpot(index) {
        let positionX = ((this.canvas.width - 2 * this.radiusMax) / (this.nbItems)) * index + this.radiusMax;
        let positionY = this.hoverHeight + this.radiusMax;

        this.items[index].percent = this.items[index].percent || 0;

        let mouseRange = Math.sqrt(Math.pow(this.cursorX - positionX, 2) + Math.pow(this.cursorY - positionY, 2))

        if (mouseRange < this.hoverRange && this.items[index].percent < 100) {
            this.items[index].percent += 10;
        }
        else if (mouseRange > this.hoverRange && this.items[index].percent > 0) {
            this.items[index].percent -= 10;
        }

        this.percentHover += this.items[index].percent;

        
        positionY = this.radiusMax + this.hoverHeight - (this.items[index].percent * 0.01 * this.hoverHeight);

        let mouseRange2 = Math.sqrt(Math.pow(this.cursorX - positionX, 2) + Math.pow(this.cursorY - positionY, 2));

        this.context.beginPath();
        this.context.arc(positionX, positionY, this.radius, 0, 2 * Math.PI);
        this.context.fillStyle = "#ffffff";
        this.context.fill();
        this.context.closePath();

        this.items[index].xSpot = positionX;
        this.items[index].ySpot = positionY;

        // click to change video
        if(mouseRange2 < this.clickRange && this.isClicked == true && this.callback) {
            this.callback(index);
        }
    }

    drawText(index) {
        this.items[index].style.opacity = (this.percentHover > 100 ? 100 : this.percentHover) * 0.01;
        this.items[index].style.left = this.items[index].xSpot + "px";
        this.items[index].style.top = (this.canvas.offsetTop + this.items[index].ySpot + this.radiusMax + 10) + "px";
    }

    drawEtape(indexStart, indexEnd) {
        let xStart = this.items[indexStart].xSpot;
        let yStart = this.items[indexStart].ySpot;
        let xEnd = (this.items[indexEnd] ? this.items[indexEnd].xSpot : ((this.canvas.width - 2 * this.radiusMax) / (this.nbItems)) * indexEnd + this.radiusMax);
        let yEnd = (this.items[indexEnd] ? this.items[indexEnd].ySpot : this.hoverHeight + this.radiusMax);

        let start = indexStart / this.nbItems * 100;
        let end = indexEnd / this.nbItems * 100;

        if (this.percentTimeline > start && this.percentTimeline < end) {
            let xMiddle = Math.round(xStart + (xEnd - xStart) * ((this.percentTimeline - start) / (end - start)));
            let yMiddle = Math.round(yStart + (yEnd - yStart) * ((this.percentTimeline - start) / (end - start)));

            this.drawLine(xStart, yStart, xMiddle, yMiddle, this.colorDone);
            this.drawLine(xMiddle, yMiddle, xEnd, yEnd, this.colorNotDone);
        }
        else if (this.percentTimeline <= start) {
            this.drawLine(xStart, yStart, xEnd, yEnd, this.colorNotDone);
        }
        else if (this.percentTimeline >= end) {
            this.drawLine(xStart, yStart, xEnd, yEnd, this.colorDone);
        }
    }

    drawLine(x1, y1, x2, y2, color) {
        this.context.beginPath();
        this.context.lineWidth = this.lineWidth;
        this.context.strokeStyle = color;
        this.context.moveTo(x1, y1);
        this.context.lineTo(x2, y2);
        this.context.stroke();
        this.context.closePath();
    }

    drawHoverCircle(index) {
        if (this.items[index].percent > 20) {
            this.context.beginPath();
            this.context.lineWidth = this.lineWidthHoverCircle;
            this.context.arc(this.items[index].xSpot, this.items[index].ySpot, Math.round(this.radiusHoverCircle * 0.01 * this.items[index].percent), 0, 2 * Math.PI);
            this.context.strokeStyle = "#e5007e";
            this.context.stroke();
            this.context.closePath();
        }
    }
}

export default Timeline;



// WEBPACK FOOTER //
// ./src/scripts/anims/timeline.js